'use client';
import React from 'react';
import { SessionProvider } from 'next-auth/react';
import IdleLogout from '@/components/IdleLogout';

export default function Providers({ children }: { children: React.ReactNode }) {
  return (
    <SessionProvider>
      {children}
      {/* Automatinis atsijungimas po neveiklumo — tik administracijai. */}
      <IdleLogout />
    </SessionProvider>
  );
}
